<template>
  <section
    class="block min-h-[53vh] max-h-[72vh] overflow-auto p-2 relative"
  >
    <div
      class="grid place-items-center grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 p-0 relative z-10"
      :key="dataTable"
    >
    <!-- {{ dataTable }} -->
      <ClientCard
        v-for="(item, index) in dataTable"
        :key="index"
        :assessment="item"
        :id="item.id"
        @set-list="setListComponentActive(SectorsList, item.name, $event)"
        @set-update-form="setUpdateForm(SectorFormUpdate, item.name, $event)"
        @export="exportBySectorId($event)"
      />
    </div>

    <div
      class="sticky -bottom-2 h-20 bg-gradient-to-t from-white to-transparent pointer-events-none z-20"
    ></div>

    <NoDataAnim
      :label="'Nenhuma noticia cadastrada'"
      v-if="dataTable?.length == 0"
    />
  </section>
</template>

<script setup>
import ExtinguisherService, { PATH } from '../../service/extinguisher.service'
import ClientCard from '../../components/_partials/ClientCard.vue'
import NoDataAnim from '@/components/Lotties/NoDataAnim.vue'
import SectorFormUpdate from '../SectorFormUpdate.vue'
import SectorsList from './SectorsList.vue'
import { showToast as toast } from '@/helpers/UseToasts'
import { dataExtinguisher } from '../../store'
import { computed, onMounted, markRaw } from 'vue'
import { initFlowbite } from 'flowbite'
import { storeApp } from '@/store'

import { PdfCreate } from '@/utils/reports/generate-blob'

const store = dataExtinguisher
const dataTable = computed(() => store.getters?.getAssessments)
const form = computed(() => store.getters?.form)

// altera para o component de listagem
async function setListComponentActive (component, pageTitle, sectorId) {
  storeApp.state.loading = true
  store.state.sectorId = undefined

  await Promise.all([
    getItensBySectorId(sectorId)
  ])

  store.dispatch('setPageTitle', pageTitle)
  store.dispatch('setBackComponent', 'SectorsCard')
  store.dispatch('setComponentActive', markRaw(component))
}

// muda para o component de atualização
async function setUpdateForm (component, pageTitle, assessmentId) {
  storeApp.state.loading = true

  store.dispatch('setPageTitle', pageTitle)
  store.dispatch('setBackComponent', 'SectorsCard')
  store.dispatch('setComponentActive', markRaw(component))

  await store.dispatch('loadAssessment', assessmentId)

  // await ExtinguisherService.assessmentById(assessmentId)
  //   .then(res => {

  //     console.log(res.data);

  //     store.dispatch('resetForm')

  //     store.state.sectorForm = res?.data
  //     store.state.sectorForm.image = res?.data?.banner
  //     store.state.sectorForm.imageName = res?.data?.banner

  //     storeApp.state.loading = false
  //   }).catch(err => {
  //     storeApp.state.loading = false

  //     if (err?.response?.data?.error && err.response.data.status === 400) {
  //       return toast(
  //         'Aviso',
  //         err.response.data.message,
  //         'error'
  //       )
  //     }

  //     return toast(
  //       'Aviso',
  //       'Algo deu errado ao buscar dados da prova',
  //       'error'
  //     )
  //   })
}

// pega todos os itens deste setor
async function getItensBySectorId (sectorId) {
  await ExtinguisherService.allExtinguishersBySector(sectorId)
    .then(res => {
      if (res?.data[0]) { store.state.sectorId = sectorId }
      store.dispatch('setItemsBySector', res?.data[0]?.itens)
      storeApp.state.loading = false
    }).catch(err => {
      storeApp.state.loading = false

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      return toast(
        'Aviso',
        'Algo deu errado ao remover setor',
        'error'
      )
    })
}

// fluxo do export
async function exportBySectorId (event) {
  toast('Aguarde...', 'Estamos exportando seu setor', 'info')

  storeApp.state.loading = true

  const url = `${process.env.VUE_APP_API_URL}${PATH}sectors/${event.id}/export-excel`
  const report = new PdfCreate(url)

  return await report.fetchExcelBySector(event.name).finally(() => {
    storeApp.state.loading = false
  })
}

onMounted(() => {
  initFlowbite()
})
</script>
